import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { Container } from "@mui/material";
import axios from "axios";
import sjcl from 'sjcl';

import { ApiCalls, axiosPost } from "../services/axios/apiCalls";
import CardLogin from "../components/login/cardLogin";
import CardPin from "../components/login/cardPin";
import Card2fa from "../components/login/card2fa";
import CardMail2fa from "../components/login/cardMail2fa";
import CardRecovery from "../components/login/cardRecovery";
import SuccessModal from "../components/modals/successModal"
import AxiosError from "../components/modals/axiosErrorModal";
import SetLoading from "../components/loading/setLoading";
import WarningModal from "../components/modals/axiosWarningModal";

function Login({ systemData }) {
  /** MESSAGE STATUS */
  const [status, setStatusError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showChangedPass, setShowChangedPass] = useState(true);

  /** COOKIES */
  const [cookies, setCookie, removeCookie] = useCookies(['login-kiwox-cookies']);

  /** CONST */
  const [loginData, setLoginData] = useState({})
  const [loading, setLoading] = useState(false)
  const [isLogin, setIsLogin] = useState(false)
  const [isTotem, setIsTotem] = useState(false)
  const [isQr, setIsQr] = useState(false)
  const [show2fa, setShow2fa] = useState(false)
  const [showMail2fa, setShowMail2fa] = useState(false)
  const [showRecovery, setShowRecovery] = useState(false)
  const [passAccessCode, setPassAccessCode] = useState(null)
  const [usernameCode, setUsernameCode] = useState(null)

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState(null);

  const encryptKey = process.env.REACT_APP_ENCRYPT_KEY;

  const backgroundImageStyle = {
    backgroundImage: `url(${systemData.bg_image})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  /** Funciones para manejar modals de error y success */
  const handleOpenErrorModal = (status, message) => {
    setStatusError(status);
    setMessageError(message);
    setShowErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
    setStatusError(null);
  };

  const handleOpenSuccessModal = (message) => {
    setMessageSuccess(message);
    setShowSuccessModal(true);
  };
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const waitForWarningModal = (message) => {
    return new Promise((resolve) => {
      setWarningMessage(message);
      setShowWarningModal(true);

      window.warningModalResolve = resolve;
    });
  };

  const handleCloseWarningModal = () => {
    setShowWarningModal(false);

    if (window.warningModalResolve) {
      window.warningModalResolve();
      window.warningModalResolve = null;
    }
  };

  // Funciones para recuperar contraseña
  const handleCloseChangedPass = async (user, pass) => {
    setShowRecovery(false)
    setIsLogin(false)
    setIsTotem(false)
    await loginUser(user, pass, 'LDAP')
  }

  async function verifyTotem(loginInfo) {
    setIsTotem(true)

    const data = {
      hash: loginInfo.hash,
      totem: loginInfo.totem,
    }

    const apiConfig = {
      method: "POST",
      baseURL: `${process.env.REACT_APP_API_URL}`,
      url: "/totem/check",
      mode: "cors",
      data,
    };

    try {
      const response = await axios(apiConfig);
      if (response.status === 200) {
      } else {
        removeCookie('login-kiwox-cookies-token')
        removeCookie('login-kiwox-cookies-redirect')
        handleOpenErrorModal(response.data.data.status, response.data.message)
        setIsTotem(false)
      }
    } catch (error) {
      handleOpenErrorModal(error.response.data.status, error.response.data.message)
      setIsTotem(false)
    }
  }

  async function loginUser(user, pass, auth_type) {
    setLoading(true)

    const environmentIdType = systemData.uuid ? '?uuid=' : '?token=';

    // Encriptamos la cadena directamente con sjcl usando AES-256 en modo CCM
    const password = sjcl.encrypt(encryptKey, pass, {
      cipher: "aes",
      mode: "ccm",
      ks: 256,
    });

    const apiConfig = {
      method: "POST",
      baseURL: `${process.env.REACT_APP_API_URL}`,
      url: "/login/authenticate",
      mode: "cors",
      data: {
        username: user,
        password,
        auth_type: auth_type,
        plattform: systemData.hash,
        channel: cookies['login-kiwox-cookies-login'] ? cookies['login-kiwox-cookies-login'].channel : 'WEB',
        uuid: systemData.uuid,
      },
    };

    try {
      const response = await ApiCalls(apiConfig);

      if (response.data.data.status === 200) {
        if (response.data.data.message && response.data.data.message.includes('expirar')) {
          console.log('Mostrando modal de advertencia');
          setLoading(false);
          await waitForWarningModal(response.data.data.message);
        }
        if (response.data.data.redirectExternalUrl) {
          setLoading(false)
          //setCookie('login-kiwox-cookies-token', JSON.stringify(response.data.data.token), { path: '/' });
          //setCookie('login-kiwox-cookies-redirect', JSON.stringify(systemData.redirect), { path: '/' });
          window.location.href = response.data.data.redirectExternalUrl
          return;
        }
        if (systemData.pass_2fa_auth && !show2fa) {
          setLoading(false)
          setLoginData({ user, auth_type: '2FA' })
          setShow2fa(true)
        } else {
          setLoading(false)
          //setCookie('login-kiwox-cookies-token', JSON.stringify(response.data.data.token), { path: '/' });
          //setCookie('login-kiwox-cookies-redirect', JSON.stringify(systemData.redirect), { path: '/' });

          // Revisa si tiene redirect
          // Si el sitio es PHP el redirect debe estar en null, si es NODE debe quedar con el redirect correspondiente
          if (!systemData.redirect) {
            // Construimos la URL con el token como parámetro GET
            const redirectUrl = `${systemData.domain}${environmentIdType}${encodeURIComponent(response.data.data.token || systemData.uuid)}`;

            // Redirigimos a la nueva URL con el token como parámetro GET
            window.location.href = redirectUrl;
          } else {
            // Usamos el dominio como redirección
            window.location.href = systemData.domain;
          }
        }
      } else if (response.data.data.status === 202 && systemData.email_verification && !showMail2fa) {
        setLoading(false)
        setLoginData({ user, auth_type: 'MAIL2FA' })
        setShowMail2fa(true)
      } else {
        setLoading(false)
        handleOpenErrorModal(response.data.data.status, response.data.message)
      }

    } catch (error) {
      if (error.status === 423) {
        setLoading(false)
        setShowRecovery(true)
        setPassAccessCode(error.response.data.data.userData.access_code)
        setUsernameCode(error.response.data.data.username)
      } else if (error.status === 409) {
        setLoading(false)
        handleOpenErrorModal(error.response.data.data.status, error.response.data.message)
      } else {
        setLoading(false)
        handleOpenErrorModal(error.response.data.data.status, error.response.data.message)
      }
    }
  }

  async function checkLogin(token) {
    const apiConfig = {
      method: "POST",
      baseURL: `${process.env.REACT_APP_API_URL}`,
      url: "/login/checkLogin",
      mode: "cors",
      data: { token },
    };

    try {
      const response = await axios(apiConfig);
      if (response.status === 200) {
        //setCookie('login-kiwox-cookies-token', JSON.stringify(response.data.data.token), { path: '/' });
        window.location.href = systemData.domain;
      } else {
        removeCookie('login-kiwox-cookies-token')
        removeCookie('login-kiwox-cookies-redirect')
        handleOpenErrorModal(response.data.data.status, response.data.message)
      }
    } catch (error) {
      handleOpenErrorModal(error.response.data.data.status, error.response.data.message)
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const siteParam = urlParams.get('site');

    if ((systemData.domain.length < 1)) return;

    // Verifica las cookies correspondientes
    const token = cookies['login-kiwox-cookies-token'] || null;
    const redirect = cookies['login-kiwox-cookies-redirect'] || null;

    const hasValidToken = token && token !== 'undefined';
    const hasValidRedirect = redirect && redirect !== 'undefined';

    if (hasValidToken && hasValidRedirect && !siteParam) {
      checkLogin(cookies['login-kiwox-cookies-token'])
    }

    // Verifica totem
    if (systemData.totem && systemData.token_pin) {
      verifyTotem(systemData)
    }

    // Verifica qr
    if (cookies['login-kiwox-cookies-login'] && cookies['login-kiwox-cookies-login'].qr && systemData.pass_qr) {
      setIsQr(true)
      loginUser(cookies['login-kiwox-cookies-login'].qr, 'default', 'QR')
    }
    // Verifica login normal
    if ((systemData.pass_auth || systemData.google_auth || systemData.microsoft_auth || systemData.apple_idms_auth) && (!systemData.totem)) {
      setIsLogin(true)
      setIsTotem(false)
    }
  }, [systemData]);

  return (
    <div className="bg-login" style={backgroundImageStyle}>
      <Container className="d-flex justify-content-center pt-5" component="main">
        {loading &&
          <SetLoading />
        }
        {(isLogin && !isQr && !isTotem && !show2fa && !showRecovery && !showMail2fa) &&
          <CardLogin systemData={systemData} loginUser={loginUser} launchErrorModal={handleOpenErrorModal} />
        }
        {show2fa && !showRecovery &&
          <Card2fa systemData={systemData} loginUser={loginUser} loginData={loginData} launchErrorModal={handleOpenErrorModal} />
        }
        {showMail2fa && !showRecovery &&
          <CardMail2fa systemData={systemData} loginUser={loginUser} loginData={loginData} launchErrorModal={handleOpenErrorModal} />
        }
        {isTotem && !showRecovery &&
          <CardPin systemData={systemData} loginUser={loginUser} />
        }
        {showRecovery &&
          <CardRecovery accessCode={passAccessCode} username={usernameCode} titleText="Su contraseña ha expirado" open={showChangedPass} onClose={handleCloseChangedPass} />
        }
      </Container>
      <AxiosError open={showErrorModal} onClose={handleCloseErrorModal} status={status} message={messageError} />
      <SuccessModal open={showSuccessModal} onClose={handleCloseSuccessModal} message={messageSuccess} />
      <WarningModal open={showWarningModal} onClose={handleCloseWarningModal} message={warningMessage} />
    </div>
  );
}

export default Login;
